.matrix-heatmap-legend-dot {
    width: 12px;
    height: 12px;
    border-radius: 999px;
    flex: none;
}

.matrix-heatmap-row-label {
    display: flex;
    flex-direction: column;
    width: 80px;
    min-width: 80px;
    max-width: 80px;
    overflow: hidden;
    margin-right: 32px;
}

.matrix-heatmap-cell {
    width: 40px;
    height: 40px;
    border-radius: 6px;
    flex: none;
}

.matrix-heatmap-column-header {
    width: 40px;
    text-align: center;
    flex: none;
}

.matrix-heatmap-metric-header {
    width: 48px;
    min-width: 48px;
    text-align: center;
    flex: none;
    margin-right: 8px;
}

.matrix-heatmap-metric {
    width: 48px;
    min-width: 48px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--off-white);
    border-radius: 6px;
    padding: 4px 6px;
    margin-right: 8px;
    overflow: hidden;
}
